module.exports = __webpack_public_path__ + "static/media/400285_02.5e99d08c.png";